import { Button, Group, Stack, Text } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';

export const AppConfirmModal = ({
  context,
  id,
  innerProps,
}: ContextModalProps<{
  modalBody: string;
  loading: boolean;
  onConfirm: () => void;
}>) => (
  <Stack>
    <Text size="sm">{innerProps.modalBody}</Text>
    <Group justify="flex-end">
      <Button variant="outline" onClick={() => context.closeModal(id)}>
        取消
      </Button>
      <Button
        color="red"
        loading={innerProps.loading}
        onClick={innerProps.onConfirm}
      >
        是，我確定
      </Button>
    </Group>
  </Stack>
);
